
<div fxLayout="row" class="dialog-title-check-box" fxLayoutGap="10px">
    <h3 mat-dialog-title>{{ 'imageTrim.title' | translate }}</h3>
</div>

<div class="form-container" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
    <div class="trim-content" fxFlex id='additional'>
        <canvas #cropCanvas id='crop-canvas' (mousedown)="mouseDown($event)" (mousemove)="mouseMove($event)"
            (mouseup)="mouseUp()"></canvas>
    </div>
</div>

<div class="actions" fxLayout="row" mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{ 'imageTrim.cancel' | translate }}</button>
</div>